import { render } from "./MaterialsInformation.vue?vue&type=template&id=7073d5a5"
import script from "./MaterialsInformation.vue?vue&type=script&lang=js"
export * from "./MaterialsInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__